import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.wallets.kyc.PersonVerificationDetails', {
    verificationDetails: 'Verification details',
    weNeedDetails:
        'We need some further details about this individual because we have a regulatory requirement to verify their identity.',
    dateOfBirth: 'Date of birth',
    dateOfBirthPlaceholder: 'Enter date...',
    street: 'Street',
    streetPlaceholder: 'Enter street...',
    buildingNumber: 'Number',
    buildingNumberPlaceholder: 'Enter number...',
    apNumber: 'Apartment number',
    apNumberPlaceholder: 'Enter apartment number...',
    buildingName: 'Building name',
    buildingNamePlaceholder: 'Enter building name...',
    state: 'State or province',
    statePlaceholder: 'Enter state or province...',
    city: 'City',
    cityPlaceholder: 'Enter city...',
    postalCode: 'Postal code',
    postalCodePlaceholder: 'Enter postal code...',
    country: 'Home country',
    countryPlaceholder: 'Select country...',
    phone: 'Phone',
    phonePlaceholder: 'Enter phone...',
    requiredField: 'Field is required',
    idNumber: 'Social security number',
    idNumberPlaceholder: 'Enter social security number...',
    idNumberInvalid: 'Invalid SSN format',
    personMustBeMoreThan18YearsOld: 'Person must be more than 18 years old',
});
